var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trainingCourseManagementWarp"},[_c('div',{staticClass:"titleBox"},[_vm._v("培训课程管理")]),_c('div',{staticClass:"tableBox"},[_c('ApplyCourse')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }